export const JSON_CONFIG_FILE_NAMES = {
  CLIENT_BUSINESS_UNITS: "client_business_units.json",
  ESTIMATION_CONFIG: "estimation_config.json",
  SUB_NAVIGATION_LABEL_CONFIG: "sub_navigation_label_config.json",
  EMPLOYEE_MANAGEMENT_CONFIG: "employee_management.json",
  LABELS_CONFIG: "labels_config.json",
  INVOICE_TEMPLATE_KEYS: "invoice_template_keys.json"
};
